module.exports = __webpack_public_path__ + "2ad2eff33668ac282f87d557860a9fc7.png";